import React, { useEffect, useState } from 'react';
import {
 Chart as ChartJS,
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar, Chart } from "react-chartjs-2";
ChartJS.register(
 CategoryScale,
 LinearScale,
 BarElement,
 PointElement,
 LineElement,
 Title,
 Tooltip,
 Legend,
 ChartDataLabels
);
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
    CardHeader,
    Button,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import Drawer from 'components/Drawer';
import PARatesDrawer from '../GridData/PARatesDrawer';
import { default as ReactSelect } from "react-select";
import useAxios from 'hooks/useAxios';

const PaRates = ({data,searchData}) => {

   const API = useAxios();
   const {dateRange, pbmPlanId, pbmGroupID,planCode, startDate, endDate,rebateflag} = searchData;
    const [isOpen, setIsOpen] = useState(false);
    const [disabledViewButtom, setDisabledViewButtom] = useState(true);
     const[paApprovedDeniedData,setpaApprovedDeniedData]=useState([]);
    const [disabledChartFilterButton, setDisabledChartFilterButton] = useState(true);
    const [graphClaimStatus,setGraphClaimStatus] = useState('PA');
    searchData.graphClaimStatus=graphClaimStatus;
    
    const PAData=[];
     const claimStatus = [
        { value: 'PA', label: 'PA' },
        { value: 'APPEAL', label: 'APPEAL' },
        { value: 'IRE', label: 'IRE' }
    ]
    useEffect(()=>{
        if(pbmPlanId==-1){
            setGraphClaimStatus("PA")
        }
        },[pbmPlanId])
  useEffect(() => {
    if (data != null && (data[0]?.labels?.length > 0 || data[0]?.approved?.length > 0 || data[0]?.denaied?.length > 0)) {
      setpaApprovedDeniedData(data)
      setDisabledViewButtom(false);
      setDisabledChartFilterButton(false);
    } else {
      setDisabledViewButtom(true);
      setpaApprovedDeniedData([]);
      setGraphClaimStatus('PA');
      setDisabledChartFilterButton(true);
    }
  }, [data]);


const getAuthPAsAndDenied=async(graphClaimStatus)=>{
        const data1 = await API.get(
            `/PBMTenant/${pbmPlanId}/PBMClientDashboard/getAuthPAsAndDenied/${planCode}/${pbmGroupID}/${dateRange}/${startDate}/${endDate}/${rebateflag}/${graphClaimStatus}`);
         PAData.push(data1.data)
         setpaApprovedDeniedData(PAData);
            if (Object.values(data1.data).every(value => value === null)){
             setDisabledViewButtom(true);
          }
          else
          {
            setDisabledViewButtom(false);
          }
      //  console.log(retailMailData);
      }

  const chartData = {
labels:paApprovedDeniedData[0]?.labels, 
   datasets: [
    
     {
       type: 'line',
       label: '% Approved',
       data:paApprovedDeniedData[0]?.approved,
       backgroundColor: 'rgba(128, 0, 77, 0.5)', 
       borderColor: 'rgba(128, 0, 64, 1)',
       fill: false,
    
     },
     {
       type: 'line',
       label: '% Denied',
       data:paApprovedDeniedData[0]?.denaied,
       backgroundColor: 'rgba(75, 0, 130, 0.5)', 
       borderColor: 'rgba(75, 0, 130, 1)',
       fill: false,
     },
   ],
 };
 
 
 const options = {
   responsive: true,
   plugins: {
     legend: {
       position: 'bottom', 
           labels: {
                        padding: 15,
                        usePointStyle: true,
                        pointStyle: 'rect',
                        color: '#707070',
                        font: {
                            weight: 'bold',
                        },
                    },
                      align: 'start',
     },
     title: {
       display: true,
      // text: 'Prior Authorization Approval & Denial Rates ',
     },
     datalabels:{
        display:false,
     
     formatter: function (value) {
                            return (
                            '%' + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '%S1,')
                        );
                        },
     anchor:'start',
     align:'end',
   },
   tooltip: {
        mode: 'index',
        intersect: false,
     callbacks: {

       label: function (d, t) {
         var xLabel = d.dataset.label;
         var yLabel = d.formattedValue + '%';
         return xLabel + ': ' + yLabel;
       },
     },
      }
    },
   scales: {
    x:{
      //  ticks: {
      //   autoSkip: false 
      // }
    },
     y: {
       beginAtZero: true,
     ticks: {
                        // include a dollar sign in the ticks
                        callback: function (value, index, values) {
                            if (value >= 1000) {
                                return (
                                    '%' + (value / 10)
                                );
                            }
                            else {
                                return (
                                    value + "%"
                                );
                            }

                        }
                    },
     },
   },
 }

 const handleActive = (title) => {
        setActive(title);
    };
    const getDate = () => {
        setActive('custom')
    }
    const handleProceed = () => {
        setIsOpen(!isOpen);
    }
    const onHandleIsOpen = (hasRefresh) => {
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
    }

       const handleStatus = (value) => {
       const datavalue= []
        setGraphClaimStatus(value.value)
        getAuthPAsAndDenied(value.value)
    }
 
 return (
    <div>
       <ErrorBoundary>
            <Card  className='p-3 h-100'>
              <CardHeader className='border-0 bg-white px-0 pt-0'>
                 <Row className="align-items-center">
                   <Col>
               <CardTitle className="f-20 font-weight-500">Prior Authorization Approval & Denial Rates </CardTitle>
                          
                 </Col>
                 </Row>
              </CardHeader>
            <CardBody className='dashboard-chart-body'>
              
             <Chart type="line" data={chartData} options={options} />
                <div className="view-report">
                        <Button
                            color='primary'
                            className='ms-2'
                            onClick={handleProceed}
                           style={{ float: "right", position: "absolute", bottom: "3px", right: "30px"}}
                            disabled={disabledViewButtom}
                        >
                            View Report
                        </Button>
                    </div>
                     <ReactSelect 
                                options={claimStatus}
                                onChange={(e) => handleStatus(e)}
                                value={
                                    claimStatus.filter(option =>
                                        option.value === graphClaimStatus)
                                }
                                className='col-4'
                                isDisabled={disabledChartFilterButton}
                            />
            </CardBody>
          </Card>
           <Drawer
                direction='end'
                title='Prior Authorization Approval & Denial Rates'
                isOpen={isOpen}
                toggle={handleProceed}
                size="lg"
            >
                <PARatesDrawer searchData={searchData}  onHandleIsOpen={onHandleIsOpen} graphClaimStatus={graphClaimStatus} />
            </Drawer> 
          </ErrorBoundary>
    </div>
 )
 

};
export default PaRates;